import { useMemo } from "react";
import type { BaseFormProps } from "../../types";

export const useFormControlProps = <T extends BaseFormProps>(props: T) => {
	const {
		name,
		error,
		label,
		labelPosition,
		isRequired,
		formHelperText,
		containerClassName,
		description,
		hideError,
		...rest
	} = props;

	const errorId = useMemo(() => `${name.replace(/\./g, "-")}-error`, [name]);

	return {
		formControlProps: {
			name,
			error,
			label,
			labelPosition,
			isRequired,
			formHelperText,
			containerClassName,
			description,
			hideError,
		},
		errorAria: error
			? {
					"aria-invalid": true,
					"aria-describedby": hideError ? undefined : errorId,
				}
			: {},
		baseProps: {
			name,
			...rest,
		},
	};
};
